import Vue from 'vue'
import 'normalize.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/search.css'
import Search from '@/entries/search/Search.vue'
import { Config } from '@/config/config'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(Config)
new Vue({
  render: h => h(Search),
}).$mount('#app')
